module.exports = __webpack_public_path__ + "img/cshomework2.46c88e4c.png";